import { EventSearchInvolvedItemFormType } from '@mark43/cad-api';
import {
    locationFormDefaultValues,
    personFormDefaultValues,
    vehicleFormDefaultValues,
} from '../search-windows/configuration';
import { DUMMY_VALUE_TO_CLEAR_RADIO_GROUP } from '../search-windows/constants';
import { EventSearchFormType } from './types';

export const propertyFormDefaultValues: EventSearchInvolvedItemFormType = {
    color: null,
    description: null,
    firearmMake: null,
    model: null,
    propertyCategory: null,
    propertyType: null,
    serialNumber: null,
};

export const eventSearchFormDefaultValues: EventSearchFormType = {
    hospitals: [],
    involvedItems: [propertyFormDefaultValues],
    agencyProfiles: [],
    agencyType: null,
    assistingAgencyProfiles: [],
    callForServices: [],
    callTakers: [],
    dateRange: null,
    dispatchAreas: [],
    dispatched: null,
    dispatchers: [],
    eventLabels: [],
    eventNumbers: [{ eventNumber: '' }],
    eventOrigins: [],
    eventQueue: null,
    fuzzyMatchingEnabled: true,
    includeActiveEvents: true,
    involvedOfficers: [],
    involvedUnits: [],
    locations: [locationFormDefaultValues],
    locationVerification: DUMMY_VALUE_TO_CLEAR_RADIO_GROUP,
    narrativeKeywords: '',
    persons: [personFormDefaultValues],
    polygonPoints: [
        { latitude: '', longitude: '' },
        { latitude: '', longitude: '' },
        { latitude: '', longitude: '' },
    ],
    primaryDispositions: [],
    primaryOfficers: [],
    primaryUnits: [],
    priorities: [],
    radioChannels: [],
    reportingEventNumbers: [{ reportingEventNumber: '' }],
    reportingEventNumberGenerated: null,
    secondaryDispositions: [],
    selfInitiated: DUMMY_VALUE_TO_CLEAR_RADIO_GROUP,
    timeRangeOption: { label: 'All Time', value: 'ALL_TIME', isCustom: false, isDefault: true },
    vehicles: [vehicleFormDefaultValues],
    hasAttachments: null,
    attachmentDescription: null,
    attachmentFileName: null,
    attachmentTypes: [],
    attachmentCategories: [],
    hasHeldTowVehicle: null,
    hasReleasedTowVehicle: null,
};
